import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { getItemWebStorage } from "../../../features/webStorageSaver";
import { logout } from "../../../features/auth";
import type { IRoadAccidents } from "../../../models/storeModels/IRoadAccidents";

function getInitialState() {
    const initialState: IRoadAccidents = {
        roadAccidentsMapFilters: getItemWebStorage("roadAccidentsMapFilters") ??
        {
            date: null,
            deathToll: "ignoreDeathToll",
            roadAccidentType: {
                ignoreRoadAccidentType: true
            },
            lightCondition: {
                ignoreLightCondition: true
            },
            coverState: {
                ignoreCoverState: true
            },
            weatherCondition: {
                ignoreWeatherCondition: true
            },
            raions: {
                ignoreRaions: true
            }
        },
        activeFiltersTabs: getItemWebStorage("roadAccidentsMapFiltersActiveTabs"),
        roadAccidentsMapFilterString: null,
        roadAccidentsMapTableFilterString: null,
        allRaionFilterValues: null,
        roadAccidentsInfo: null
    };
    return initialState
}

export const roadAccidentsSlice = createSlice({
    name: 'roadAccidents',
    initialState: getInitialState(),
    reducers: {
        setRoadAccidentsMapFilters(state, action: PayloadAction<any>) {
            state.roadAccidentsMapFilters = action.payload
        },
        setRoadAccidentsActiveFiltersTabs(state, action: PayloadAction<any>) {
            state.activeFiltersTabs = action.payload
        },
        setRoadAccidentsMapFilterString(state, action: PayloadAction<any>) {
            state.roadAccidentsMapFilterString = action.payload
        },
        setRoadAccidentsMapTableFilterString(state, action: PayloadAction<any>) {
            state.roadAccidentsMapTableFilterString = action.payload
        },
        setRoadAccidentsAllRaionMapFilterValues(state, action: PayloadAction<any>) {
            state.allRaionFilterValues = action.payload
        },
        setRoadAccidentsInfo(state, action: PayloadAction<any>) {
            state.roadAccidentsInfo = action.payload
        },
    },
    extraReducers: (builder) => {
        builder.addCase(logout, () => {
            return getInitialState()
        })
    },
})

export const {
    setRoadAccidentsMapFilters,
    setRoadAccidentsInfo,
    setRoadAccidentsMapTableFilterString,
    setRoadAccidentsMapFilterString,
    setRoadAccidentsActiveFiltersTabs,
    setRoadAccidentsAllRaionMapFilterValues
} = roadAccidentsSlice.actions
export const roadAccidentsReducer = roadAccidentsSlice.reducer;
